import { Button } from "components";
import Link, { LinkProps } from "next/link";
import React, { FC, Fragment, PropsWithChildren, ReactNode } from "react";
import {
  commafy,
  convertMiladiToJalali,
  getClassFormat,
  getColorByEnum,
} from "src/utils";

type Props = {
  item: any;
  type?: "ARTICLES" | "SEARCH";
};

const Items: FC<Props> = ({ item, type = "SEARCH" }) => {
  const getType = (item: any, type: string) => {
    const found = item.items.filter((values: any) => values.fieldName === type);
    if (found && found.length) {
      if (type === "Image") {
        return found[0].value ?? "images/nc-img.png";
      }
      if (type === "Price" || type === "Discount") {
        return found[0].value.replaceAll(".00", "");
      }
      return found[0].value;
    }
    return undefined;
  };
  return (
    <li className="flex min-h-[150px] flex-col divide-y-2 py-5 first-of-type:pt-0">
      <div
        className={`relative z-[1] grid h-auto w-full cursor-pointer grid-cols-1 flex-col justify-start  gap-x-5 md:grid-cols-[_230px,1fr]`}
      >
        <Link
          href={
            type === "ARTICLES"
              ? {
                  href: `/article/${item?.id}`,
                  pathname: getType(item, "SeoUrlDescription")
                    ? `/article/${item?.id}/${encodeURIComponent(
                        getType(item, "SeoUrlDescription")
                      )}`
                    : `/article/${item?.id}`,
                }
              : {
                  href:
                    +getType(item, "EntityType") == 0
                      ? `/course/${item?.id}`
                      : `/package-details/${item?.id}`,
                  pathname: getType(item, "SeoUrlDescription")
                    ? +getType(item, "EntityType") == 0
                      ? `/course/${item?.id}/${encodeURIComponent(
                          getType(item, "SeoUrlDescription")
                        )}`
                      : `/package-details/${item?.id}/${encodeURIComponent(
                          getType(item, "SeoUrlDescription")
                        )}`
                    : +getType(item, "EntityType") == 0
                    ? `/course/${item?.id}`
                    : `/package-details/${item?.id}`,
                }
          }
        >
          <a className="relative -z-10 ml-auto flex h-[250px] w-full items-center md:m-0 md:h-auto md:w-[260px]">
            <div
              className="h-[200px] w-[262px] min-w-[260px] justify-self-start rounded-lg md:h-[140px] md:w-[140px] md:justify-self-auto xl:h-[160px] xl:w-[169px]"
              style={{
                background:
                  "linear-gradient(238.69deg, rgba(54, 100, 147, 0.88) 3.2%, rgba(4, 128, 212, 0.88) 44.48%, rgba(39, 177, 187, 0.88) 83.25%)",
              }}
            />
            <img
              loading="lazy"
              src={getType(item, "Image")}
              alt="person"
              style={{ transform: "translate(-10px, -50%)" }}
              className="absolute top-1/2 aspect-auto w-full rounded-lg object-fill"
            />
          </a>
        </Link>
        <Link
          shallow={true}
          href={
            type === "ARTICLES"
              ? {
                  href: `/article/${item?.id}`,
                  pathname: getType(item, "SeoUrlDescription")
                    ? `/article/${item?.id}/${encodeURIComponent(
                        getType(item, "SeoUrlDescription")
                      )}`
                    : `/article/${item?.id}`,
                }
              : {
                  href:
                    +getType(item, "EntityType") == 0
                      ? `/course/${item?.id}`
                      : `/package-details/${item?.id}`,
                  pathname: getType(item, "SeoUrlDescription")
                    ? +getType(item, "EntityType") == 0
                      ? `/course/${item?.id}/${encodeURIComponent(
                          getType(item, "SeoUrlDescription")
                        )}`
                      : `/package-details/${item?.id}/${encodeURIComponent(
                          getType(item, "SeoUrlDescription")
                        )}`
                    : +getType(item, "EntityType") == 0
                    ? `/course/${item?.id}`
                    : `/package-details/${item?.id}`,
                }
          }
        >
          <a className="mt-4 flex h-auto flex-col gap-y-2 md:mr-10 md:mt-0 md:flex-row md:justify-between md:gap-y-0">
            <div className="ml-auto flex flex-col justify-evenly space-y-2 md:m-0 md:space-y-0">
              <span className="flex w-full items-center justify-between text-[11px] md:justify-start md:text-[13px] lg:text-[17px]">
                {type == "SEARCH"
                  ? getType(item, "Name")
                  : getType(item, "Title")}
                {type !== "ARTICLES" &&
                  (+getType(item, "EntityType") === 0 ||
                    +getType(item, "EntityType") === 1) && (
                    <span
                      style={{
                        color: getColorByEnum(+getType(item, "CourseType"))
                          .fontColor,
                        background: getColorByEnum(+getType(item, "CourseType"))
                          .bgColor,
                      }}
                      className={`bg-[${getColorByEnum(
                        +getType(item, "CourseType")
                      )}] mr-2 h-min rounded-full px-5 py-1 text-xs md:flex`}
                    >
                      {getClassFormat(+getType(item, "CourseType"))}
                    </span>
                  )}
              </span>

              <p className="text-xs md:text-[15px] lg:text-lg">
                {(getType(item, "Description") as string)?.length > 50
                  ? getType(item, "Description")?.slice(0, 50) + "..."
                  : getType(item, "Description")}
              </p>
              <div className="flex text-[9px] text-[#919191] md:gap-x-1 md:text-[11px] lg:text-[15px]">
                {type == "SEARCH" &&
                  (getType(item, "TeacherNames") ? (
                    <span>{getType(item, "TeacherNames")}.</span>
                  ) : undefined)}
                {+getType(item, "EntityType") !== 1 ||
                +getType(item, "CourseType") !== 2 ? (
                  <>
                    {type == "SEARCH" ? (
                      <span>
                        {getType(item, "StartDate") &&
                        getType(item, "StartDate").length
                          ? `${convertMiladiToJalali(
                              getType(item, "StartDate")
                            )}.`
                          : `${convertMiladiToJalali(
                              getType(item, "ReleaseDatetime")
                            )}.`}
                      </span>
                    ) : getType(item, "ArticleWriter") ? (
                      <span className="w-1/2 md:w-auto">
                        پدیدآورنده {getType(item, "ArticleWriter")}.
                      </span>
                    ) : undefined}
                  </>
                ) : undefined}
                <span>{getType(item, "ViewCount")} بازدید</span>
                {type == "ARTICLES" &&
                getType(item, "TimeToRead") &&
                getType(item, "TimeToRead").length ? (
                  <span>
                    زمان مطالعه/مشاهده {getType(item, "TimeToRead")} دقیقه
                  </span>
                ) : undefined}
              </div>
              {!(getType(item, "IsBuyable") === "True") && type == "SEARCH" && (
                <span className="mt-3 text-xs text-[#F46A6A] md:text-base">
                  (فرصت شرکت در این دوره به اتمام رسیده است)
                </span>
              )}
            </div>
            <div className="flex flex-col justify-evenly space-y-2 md:space-y-0">
              {getType(item, "IsBuyable") === "True" && (
                <>
                  <span className="whitespace-nowrap text-left text-xs md:text-sm lg:text-base">
                    {getType(item, "IsFree") === "True"
                      ? "رایگان"
                      : +getType(item, "Discount") !== null &&
                        +getType(item, "Discount") !== 0
                      ? commafy(getType(item, "Discount"))
                      : commafy(getType(item, "Price"))}
                    {!(getType(item, "IsFree") === "True") && "تومان"}
                  </span>
                  {+getType(item, "Discount") !== null &&
                    +getType(item, "Discount") !== 0 && (
                      <span className="flex items-center self-end whitespace-nowrap text-left text-[10px] text-[#919191] line-through md:text-xs lg:text-[15px]">
                        {getType(item, "Price") &&
                          commafy(getType(item, "Price"))}{" "}
                        تومان
                      </span>
                    )}
                </>
              )}
              {type == "SEARCH" && (
                <Button
                  spinnerColor="blue"
                  // isLoading={payLoading}
                  // onClick={(e) => {
                  //     e.stopPropagation();
                  //     handlePay({
                  //         discount: getType(item, "Discount"),
                  //         price: getType(item, "Price"),
                  //         id: item?.id,
                  //         entityType: +getType(item, "EntityType"),
                  //     });
                  // }}
                  disabled={!(getType(item, "IsBuyable") === "True")}
                  className="z-50 mt-2 cursor-pointer whitespace-nowrap rounded border border-blue-550 py-[7px] px-[10px] text-xs text-blue-550 disabled:border-[#B8B7B7] disabled:text-[#B8B7B7] md:mt-0 md:text-sm lg:text-base"
                >
                  {getType(item, "IsFree") === "True"
                    ? "افزودن به سبد خرید"
                    : "افزودن به سبد خرید"}
                </Button>
              )}
            </div>
          </a>
        </Link>
      </div>
    </li>
  );
};

export default Items;
